import * as Sentry from "@sentry/browser";
import { get as _get} from "lodash";

export const SERVICE_MONITORING = 'monitoring';
export const CATEGORY_ANALYTICS = 'analytics';

export function getSentryConfig(i18n) {
    const lang = i18n.locale;
    const labels = {
        [lang]: i18n.t('tekst Monitorowanie błędów Sentry (cookie consent)'),
    };

    return {
        category: CATEGORY_ANALYTICS,
        service: SERVICE_MONITORING,
        config: {
            label: labels[lang] || labels['en']
        },
        cookieTable: {
            body: [
                {
                    name: "sentry-sc",
                    domain: "Sentry",
                    description: lang === 'pl' ? "Plik cookie ustawiony przez Sentry do śledzenia sesji i monitorowania błędów w czasie rzeczywistym" :
                                 lang === 'ua' ? "Файл cookie, встановлений Sentry для відстеження сесії та моніторингу помилок у реальному часі" :
                                 "Cookie set by Sentry for session tracking and real-time error monitoring",
                    expiration: lang === 'pl' ? "Sesja" :
                                lang === 'ua' ? "Сесія" :
                                "Session"
                }
            ]
        },
        autoClear: {
            cookies: [
                { name: 'sentry-sc' },
                { name: /^_sentry_/ }
            ]
        }
    };
}

export default function initializeSentry() {
    if (window.scriptsLoaded.sentry || !import.meta.env.VITE_SENTRY_DSN) return;

    const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
    const currentUser = typeof AuthUser !== 'undefined' ? AuthUser : {};
    const sentry_session_replay = _get(currentUser, 'instance.sentry_session_replay');
        Sentry.init({
            dsn: sentryDsn,
            integrations: [
                Sentry.browserTracingIntegration(),
                ...(!!sentry_session_replay ? [Sentry.replayIntegration()] : [])
            ],
            tracesSampleRate: 0.2,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            beforeSend(event, hint) {
                const error = hint.originalException;
                if (error && error.response && error.response.headers) {
                    const ignoreSentryHeader = error.response.headers.get('X-Ignore-Sentry');
                    if (ignoreSentryHeader === 'true') {
                        return null;
                    }
                }

                const listOfErrorMessagesToIgnore = [
                    'Request failed with status code 401',
                    'Request failed with status code 403',
                    'Request failed with status code 404',
                    'Request failed with status code 419',
                    'Request failed with status code 422',
                    'Request failed with status code 503'
                ];

                // exception.value to string z komunikatem, nigdy obiekt — sprawdzenie
                // instanceof jQuery.Event miało tu sens zerowy. Zdarzenie jQuery trzeba
                // rozpoznać na surowym wyjątku z hint.originalException (S3-11591).
                if (error instanceof jQuery.Event) {
                    return null;
                }

                if (event.exception && event.exception.values) {
                    for (const exception of event.exception.values) {
                        if (exception.value && listOfErrorMessagesToIgnore.includes(exception.value)) {
                            return null;
                        }
                    }
                }

                return event;
            },
            ignoreErrors: [
                'NavigationDuplicated',
                /Navigation cancelled from/,
                /Redirected when going from/,
                /Navigation aborted from/,
                /Avoided redundant navigation/,
                'Network Error',
                'Request aborted',
                /^TypeError: Failed to fetch dynamically imported module/,
                /^SQLSTATE\[HY000\] \[2002\] Connection refused.*/,
                /^The check named `.*` did not complete.*/
            ]
        });
    window.scriptsLoaded.sentry = true;
}

export const cookieCallbacks = {
    onFirstConsent: (cookie, utils) => {
        const acceptedServices = Object.values(cookie.services || []).flat();

        if (acceptedServices.includes(SERVICE_MONITORING)) {
            initializeSentry();
        }
    },

    onConsent: (cookie, utils) => {
        const acceptedServices = Object.values(cookie.services || []).flat();

        if (acceptedServices.includes(SERVICE_MONITORING)) {
            initializeSentry();
        }
    },

    onChange: (cookie, changedCategories, changedServices, utils) => {
        const acceptedServices = Object.values(cookie.services || []).flat();

        if (acceptedServices.includes(SERVICE_MONITORING)) {
            initializeSentry();
        }
    }
}
